import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import useAuth from "../hooks/useAuth";
import useRefreshToken from "../hooks/useRefreshToken";

import Loader from "./Loader";

const PersistentLogin = () => {
  const { auth } = useAuth();
  const refreshToken = useRefreshToken();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const verifyAccessToken = async () => {
      try {
        await refreshToken();
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    if (!auth?.accessToken) {
      verifyAccessToken();
    } else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) {
    return (
      <div className="flex min-h-screen">
        <Loader />
      </div>
    );
  }

  return <Outlet />;
};

export default PersistentLogin;
